import * as React from "react"
import SlidingText from "@components/SlidingText"

const StrapiSlidingText = ({ text }: GatsbyTypes.SlidingTextFragment) => {
    if (!text) {
        return
    }

    return <SlidingText>{text}</SlidingText>
}

export default StrapiSlidingText
